import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const PencilSquare = t0 => {
  const $ = _c(6);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path id="Vector" d="M10.0506 25.7467L12.3853 19.9099C12.7574 18.9801 13.3144 18.1355 14.0226 17.4272L26.8246 4.62893C27.5605 3.89296 28.5587 3.47949 29.5996 3.47949C30.6404 3.47949 31.6386 3.89296 32.3746 4.62893C33.1105 5.36491 33.524 6.36311 33.524 7.40393C33.524 8.44476 33.1105 9.44296 32.3746 10.1789L19.5726 22.9772C18.864 23.6858 18.0186 24.2445 17.088 24.6163L11.2531 26.951C11.085 27.0183 10.9009 27.0348 10.7235 26.9984C10.5461 26.962 10.3833 26.8744 10.2553 26.7463C10.1273 26.6183 10.0396 26.4555 10.0032 26.2782C9.96686 26.1008 9.98333 25.9166 10.0506 25.7485V25.7467Z" />;
    t2 = <path id="Vector_2" d="M6.47422 10.6373C6.47422 9.3608 7.51022 8.3248 8.78672 8.3248H18.4992C18.8672 8.3248 19.2201 8.17862 19.4803 7.91842C19.7405 7.65821 19.8867 7.30529 19.8867 6.9373C19.8867 6.56932 19.7405 6.2164 19.4803 5.95619C19.2201 5.69599 18.8672 5.5498 18.4992 5.5498H8.78672C7.43743 5.5498 6.1434 6.08581 5.18931 7.0399C4.23522 7.99399 3.69922 9.28802 3.69922 10.6373V28.2123C3.69922 29.5616 4.23522 30.8556 5.18931 31.8097C6.1434 32.7638 7.43743 33.2998 8.78672 33.2998H26.3617C27.711 33.2998 29.005 32.7638 29.9591 31.8097C30.9132 30.8556 31.4492 29.5616 31.4492 28.2123V18.4998C31.4492 18.1318 31.303 17.7789 31.0428 17.5187C30.7826 17.2585 30.4297 17.1123 30.0617 17.1123C29.6937 17.1123 29.3408 17.2585 29.0806 17.5187C28.8204 17.7789 28.6742 18.1318 28.6742 18.4998V28.2123C28.6742 29.4888 27.6382 30.5248 26.3617 30.5248H8.78672C7.51022 30.5248 6.47422 29.4888 6.47422 28.2123V10.6373Z" />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props) {
    t3 = <IconWrapper {...props} variant="solid" viewBox="0 0 36 36">{t1}{t2}</IconWrapper>;
    $[4] = props;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export { PencilSquare };